import React from "react"
import { AutocompleteAjaxSeeker } from "@ui-seeker/core"

import { BACKEND_APIS } from "@constants"


export default function AppAcrissAutocomplete({ ...props }) {
    return <AutocompleteAjaxSeeker
		filterSelectedOptions={false}
        multiple
		label="Acriss"
		placeholder="All acriss"
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/options/acriss`}
		{...props}
	/>
}